/* emv/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const DataCodec = t.string;
export type Data = t.ArrayType<typeof DataCodec>;

export const TerminalAppCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(t.string)),
  },
  "TerminalAppCodec"
);
export const VersionString = t.type(
  {
    applicationData: tOptional(t.any),
    versions: tOptional(t.any),
    application: t.string,
  },
  "VersionString"
);

export type Application = t.TypeOf<typeof TerminalAppCodec>;

export type Version = t.TypeOf<typeof VersionString>;

export enum ApplicationActionTypes {
  FETCH = "@@terminalApp/FETCH",
  FETCH_SUCCESS = "@@terminalApp/FETCH_SUCCESS",
  FETCH_ERROR = "@@terminalApp/FETCH_ERROR",
  FETCH_VERSION = "@@terminalApp/FETCH_VERSION",
  FETCH_VERSION_SUCCESS = "@@terminalApp/FETCH_VERSION_SUCCESS",
  FETCH_VERSION_ERROR = "@@terminalApp/FETCH_VERSION_ERROR",
  FETCH_FIRMWARE = "@@terminalApp/FETCH_FIRMWARE",
  FETCH_FIRMWARE_SUCCESS = "@@terminalApp/FETCH_FIRMWARE_SUCCESS",
  FETCH_FIRMWARE_ERROR = "@@terminalApp/FETCH_FIRMWARE_ERROR",
}

export interface MyAxisState {
  readonly loading: boolean;
  readonly applications: any;
  readonly firmwares?: any;
  readonly errors?: string;
  readonly versions?: any;
}
